/**
 * Pinia Data Store for Cirrus Reader Data
 * Contains a store for anything related to the reading experience including current page, renderer etc
 */

import type { ISimpleLocatorData } from '@colibrio/colibrio-reader-framework/colibrio-core-locator';
import type { IVisibleContentRectData } from '@colibrio/colibrio-reader-framework/colibrio-readingsystem-base';
import { defineStore } from 'pinia'
import type { ICirrusReaderContentActiveSelectionStateData } from '../shared/CirrusReaderModel';

interface PopoverState {
  open?: boolean,
  startX?: number,
  startY?: number,
  endX?: number,
  endY?: number,  
  anchorRect?: IVisibleContentRectData,
  selectionRect?: IVisibleContentRectData[],
  selectionText?: string,
  selectionLocatorData?: ISimpleLocatorData,
}

interface CirrusReaderUiState {
  navigationAvailable: boolean,
  bottomDrawerOpen: boolean,
  leftDrawerOpen: boolean,
  rightDrawerOpen: boolean,
  readAloudOpen: boolean,
  readerPopoverData: PopoverState | null,
  activeSelection?: ICirrusReaderContentActiveSelectionStateData
}


export const useCirrusReaderUiStore = defineStore('cirrusReaderUi', {
  state: (): CirrusReaderUiState => ({
    navigationAvailable: false,
    bottomDrawerOpen: false,
    leftDrawerOpen: false,
    rightDrawerOpen: false,
    readAloudOpen: false,
    readerPopoverData: null,
  }),
  actions: {
    setNavigationAvailable(value: boolean) {
      this.navigationAvailable = value;
    },
    toggleBottomDrawer(value?: boolean) {
      if (value !== undefined) {
        this.bottomDrawerOpen = value;
        return;
      }
      this.bottomDrawerOpen = !this.bottomDrawerOpen;
    },
    toggleLeftDrawer(value?: boolean) {
      if (value !== undefined) {
        this.leftDrawerOpen = value;
        return;
      }
      this.leftDrawerOpen = !this.leftDrawerOpen;
    },
    toggleRightDrawer(value?: boolean) {
      if (value !== undefined) {
        this.rightDrawerOpen = value;
        return;
      }
      this.rightDrawerOpen = !this.rightDrawerOpen;
    },
    toggleReadAloud(value?: boolean) {
      if (value !== undefined) {
        this.readAloudOpen = value;
        return;
      }
      this.readAloudOpen = !this.readAloudOpen;
    },
    getPopoverState(): PopoverState | null {
      return this.readerPopoverData;
    },
    setPopoverState(state: Partial<PopoverState> | undefined) {
      this.readerPopoverData = {
        ...this.readerPopoverData,
        ...state
      };
    },
    setActiveSelection(activeSelection: ICirrusReaderContentActiveSelectionStateData | undefined){
      this.activeSelection = activeSelection;
    },
    getActiveSelection(): ICirrusReaderContentActiveSelectionStateData | null {
      return this.activeSelection ?? null;
    }
  }
});
